import type { ConnectorDefinition } from '#layers/data-model/types/data-connectors/define';
import { dataConnectorDefinitions } from '#layers/data-model/data-connectors';

const mappedConnectors = Object.fromEntries(
	dataConnectorDefinitions.map((connector) => [connector.id, connector]),
) as Record<string, ConnectorDefinition>;

export default mappedConnectors;
